export default "__VITE_ASSET__BsndNQ40__"